import { render, staticRenderFns } from "./myPost.vue?vue&type=template&id=5f9a5d3a&scoped=true&"
import script from "./myPost.vue?vue&type=script&lang=js&"
export * from "./myPost.vue?vue&type=script&lang=js&"
import style0 from "./myPost.vue?vue&type=style&index=0&id=5f9a5d3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a5d3a",
  null
  
)

export default component.exports